export type Collection = {
  id: string;
  title: string;
  circle: string;
  format: string;
  views: number;
  likes: number;
  chapters: number;
  tags: string[];
  cover: string;
  desc: string;
  hot?: boolean;
};

export const formats = [
  {
    id: "comic",
    icon: "ri-book-open-line",
    name: "漫画本",
    en: "Comic",
    count: 1280,
    desc: "完整剧情向的原创与二次创作漫画本，一本看完一个完整故事。",
  },
  {
    id: "album",
    icon: "ri-image-line",
    name: "插画画集",
    en: "Art Album",
    count: 860,
    desc: "插画师精选作品集结成册，色彩与构图一次看个够。",
  },
  {
    id: "yonkoma",
    icon: "ri-layout-grid-line",
    name: "四格漫画",
    en: "4-Panel",
    count: 540,
    desc: "轻松诙谐的四格段子，节奏明快，适合碎片时间随手一翻。",
  },
  {
    id: "webcomic",
    icon: "ri-phone-line",
    name: "网络条漫",
    en: "Webcomic",
    count: 730,
    desc: "专为手机屏幕设计的纵向条漫，追更阅读更顺畅。",
  },
  {
    id: "anthology",
    icon: "ri-bookmark-line",
    name: "短篇合集",
    en: "Anthology",
    count: 420,
    desc: "多位作者短篇集结的同人志合集，风格多元、惊喜不断。",
  },
];

export const trending: Collection[] = [
  {
    id: "t1",
    title: "盛夏的社团活动室",
    circle: "午后三点",
    format: "漫画本",
    views: 48200,
    likes: 3210,
    chapters: 6,
    tags: ["校园", "日常", "连载"],
    desc: "关于放学后的社团活动室，一段盛夏限定的温柔群像。",
    cover: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cozy%20school%20club%20room%20afternoon%20with%20sunlight%20through%20windows%2C%20warm%20terracotta%20and%20amber%20tones%2C%20soft%20lighting%2C%20manga%20cover%20art%2C%20clean%20composition&width=800&height=1130&seq=cover-t1&orientation=portrait",
    hot: true,
  },
  {
    id: "t2",
    title: "星野事务所的画稿簿",
    circle: "白日梦画室",
    format: "插画画集",
    views: 61800,
    likes: 4520,
    chapters: 12,
    tags: ["原创", "幻想", "全彩"],
    desc: "插画师「星野」三年作品精选，收录 120 张全彩画稿与幕后线稿。",
    cover: "https://readdy.ai/api/search-image?query=anime%20illustration%20collection%20book%20cover%20with%20dreamy%20starry%20sky%20and%20a%20girl%20with%20long%20hair%2C%20full%20color%2C%20warm%20golden%20and%20coral%20palette%2C%20soft%20glow%2C%20art%20album%20cover%20style&width=800&height=1130&seq=cover-t2&orientation=portrait",
    hot: true,
  },
  {
    id: "t3",
    title: "今天也要元气满满",
    circle: "布丁社",
    format: "四格漫画",
    views: 35500,
    likes: 2180,
    chapters: 24,
    tags: ["搞笑", "日常", "四格"],
    desc: "每天一格的元气四格，记录社团里鸡飞狗跳的欢乐日常。",
    cover: "https://readdy.ai/api/search-image?query=funny%20four%20panel%20comic%20book%20cover%20with%20chibi%20anime%20characters%20laughing%20and%20jumping%2C%20bright%20playful%20colors%2C%20warm%20orange%20and%20cream%2C%20cartoon%20style&width=800&height=1130&seq=cover-t3&orientation=portrait",
  },
  {
    id: "t4",
    title: "山海旅人·画集",
    circle: "未明工作室",
    format: "插画画集",
    views: 52700,
    likes: 3860,
    chapters: 8,
    tags: ["国风", "山海", "全彩"],
    desc: "以山海经为灵感的原创国风插画集，笔墨与色彩交织的奇幻之旅。",
    cover: "https://readdy.ai/api/search-image?query=traditional%20chinese%20fantasy%20illustration%20art%20book%20cover%20with%20mystical%20mountains%20and%20mythical%20beasts%2C%20ink%20wash%20with%20warm%20gold%20and%20terracotta%20accents%2C%20elegant%20composition&width=800&height=1130&seq=cover-t4&orientation=portrait",
    hot: true,
  },
  {
    id: "t5",
    title: "便利店夜晚的来客",
    circle: "深夜食堂组",
    format: "网络条漫",
    views: 40600,
    likes: 2740,
    chapters: 18,
    tags: ["治愈", "都市", "条漫"],
    desc: "深夜便利店里发生的温柔相遇，适合睡前慢慢追更的治愈条漫。",
    cover: "https://readdy.ai/api/search-image?query=vertical%20webcomic%20cover%20of%20a%20cozy%20night%20convenience%20store%20interior%20with%20warm%20light%20and%20two%20anime%20characters%20talking%2C%20soothing%20night%20tones%2C%20coral%20and%20cream%20palette&width=800&height=1130&seq=cover-t5&orientation=portrait",
  },
  {
    id: "t6",
    title: "四月初的信",
    circle: "信笺社团",
    format: "短篇合集",
    views: 28900,
    likes: 1980,
    chapters: 10,
    tags: ["青春", "书信", "合集"],
    desc: "六位作者以「信」为主题的短篇同人志合集，细腻而温暖。",
    cover: "https://readdy.ai/api/search-image?query=anime%20short%20story%20anthology%20cover%20with%20letters%20and%20envelopes%20floating%20in%20spring%20breeze%20cherry%20blossoms%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20romantic%20mood&width=800&height=1130&seq=cover-t6&orientation=portrait",
  },
  {
    id: "t7",
    title: "光与影的剑士",
    circle: "折剑社",
    format: "漫画本",
    views: 44100,
    likes: 3090,
    chapters: 4,
    tags: ["战斗", "热血", "完结"],
    desc: "热血战斗向原创同人志，一场关于守护与救赎的完整旅程。",
    cover: "https://readdy.ai/api/search-image?query=epic%20action%20manga%20cover%20with%20a%20swordsman%20silhouette%20in%20dramatic%20light%20and%20shadow%2C%20dynamic%20pose%2C%20warm%20orange%20and%20dark%20ink%20contrast%2C%20cinematic&width=800&height=1130&seq=cover-t7&orientation=portrait",
  },
  {
    id: "t8",
    title: "猫尾巴的秘密",
    circle: "软乎乎工坊",
    format: "四格漫画",
    views: 31200,
    likes: 2050,
    chapters: 30,
    tags: ["萌宠", "治愈", "四格"],
    desc: "住在猫咖里的毛茸茸日常，一格一格都是治愈能量。",
    cover: "https://readdy.ai/api/search-image?query=adorable%20anime%20cat%20cafe%20four%20panel%20comic%20cover%20with%20fluffy%20cats%20and%20a%20barista%2C%20warm%20cream%20and%20coral%20colors%2C%20kawaii%20chibi%20style%2C%20playful&width=800&height=1130&seq=cover-t8&orientation=portrait",
  },
];

export const editorPicks = [
  {
    id: "p1",
    title: "风与列车",
    circle: "车窗之外",
    format: "漫画本",
    views: 21300,
    likes: 1540,
    chapters: 5,
    tags: ["旅行", "青春"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20train%20window%20with%20scenery%20flying%20by%20and%20a%20thoughtful%20youth%20beside%20it%2C%20warm%20golden%20hour%20light%2C%20travel%20nostalgia%2C%20soft%20watercolor%20feel&width=800&height=1000&seq=pick-p1&orientation=portrait",
    desc: "编辑推荐：把青春写进窗外的风景里，一趟列车的完整人生片段。",
  },
  {
    id: "p2",
    title: "雨天书店",
    circle: "纸页之间",
    format: "短篇合集",
    views: 18700,
    likes: 1320,
    chapters: 7,
    tags: ["治愈", "书店"],
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20bookstore%20interior%20on%20a%20rainy%20day%20with%20warm%20lamplight%20and%20shelves%20of%20books%2C%20short%20story%20anthology%20cover%2C%20warm%20cream%20and%20coral%20tones&width=800&height=1000&seq=pick-p2&orientation=portrait",
    desc: "编辑推荐：雨天与书店是绝配，七则关于纸页与记忆的短篇。",
  },
  {
    id: "p3",
    title: "四季花园",
    circle: "草木集",
    format: "插画画集",
    views: 24900,
    likes: 1780,
    chapters: 6,
    tags: ["自然", "全彩"],
    cover: "https://readdy.ai/api/search-image?query=beautiful%20anime%20botanical%20garden%20art%20album%20cover%20showing%20four%20seasons%20flowers%20and%20plants%2C%20warm%20watercolor%20style%2C%20terracotta%20and%20soft%20green%20palette&width=800&height=1000&seq=pick-p3&orientation=portrait",
    desc: "编辑推荐：把一整年的花开都装进画集里，四季皆宜。",
  },
  {
    id: "p4",
    title: "屋顶上的约定",
    circle: "天台见",
    format: "网络条漫",
    views: 16500,
    likes: 1180,
    chapters: 14,
    tags: ["恋爱", "校园"],
    cover: "https://readdy.ai/api/search-image?query=anime%20webcomic%20cover%20of%20a%20school%20rooftop%20at%20sunset%20with%20two%20characters%20making%20a%20promise%2C%20warm%20golden%20and%20rose%20tones%2C%20romantic%20mood&width=800&height=1000&seq=pick-p4&orientation=portrait",
    desc: "编辑推荐：屋顶与黄昏的青春约定，甜甜的校园恋爱条漫。",
  },
];

export const themes = [
  { id: "g1", name: "校园日常", count: 326, cover: "https://readdy.ai/api/search-image?query=anime%20school%20life%20illustration%20with%20students%20on%20a%20campus%20under%20warm%20sunlight%2C%20everyday%20youth%20scenes%2C%20soft%20warm%20tones&width=600&height=480&seq=theme-g1&orientation=landscape" },
  { id: "g2", name: "奇幻冒险", count: 268, cover: "https://readdy.ai/api/search-image?query=fantasy%20adventure%20anime%20illustration%20of%20a%20party%20of%20adventurers%20crossing%20a%20magical%20landscape%2C%20warm%20sunset%20and%20moss%20green%20palette&width=600&height=480&seq=theme-g2&orientation=landscape" },
  { id: "g3", name: "治愈温情", count: 214, cover: "https://readdy.ai/api/search-image?query=heartwarming%20anime%20illustration%20of%20a%20family%20having%20dinner%20together%20in%20a%20cozy%20warm%20room%2C%20gentle%20light%2C%20tender%20mood&width=600&height=480&seq=theme-g3&orientation=landscape" },
  { id: "g4", name: "热血战斗", count: 189, cover: "https://readdy.ai/api/search-image?query=passionate%20action%20anime%20scene%20of%20two%20fighters%20clashing%20with%20energy%20effects%2C%20warm%20orange%20flames%20and%20dark%20shadows%2C%20dramatic&width=600&height=480&seq=theme-g4&orientation=landscape" },
  { id: "g5", name: "恋爱喜剧", count: 176, cover: "https://readdy.ai/api/search-image?query=romantic%20comedy%20anime%20illustration%20of%20two%20awkward%20teens%20blushing%20in%20a%20cherry%20blossom%20park%2C%20warm%20rose%20and%20cream%20tones%2C%20playful&width=600&height=480&seq=theme-g5&orientation=landscape" },
  { id: "g6", name: "悬疑惊悚", count: 143, cover: "https://readdy.ai/api/search-image?query=mystery%20thriller%20anime%20scene%20of%20a%20dimly%20lit%20alleyway%20with%20a%20silhouette%2C%20warm%20amber%20streetlight%20and%20deep%20shadows%2C%20suspenseful&width=600&height=480&seq=theme-g6&orientation=landscape" },
];

export const testimonials = [
  {
    id: "r1",
    name: "林同学",
    role: "漫画本收藏党",
    text: "终于不用在各种贴吧和网盘里翻来翻去了。同人志按格式打包得清清楚楚，漫画本和短篇合集一键就能整本看完，收藏起来特别方便。",
  },
  {
    id: "r2",
    name: "柚子茶",
    role: "插画爱好者",
    text: "画集分区做得很用心，全彩大图看着很舒服。编辑精选每一期都踩在我的审美点上，经常能发现新的宝藏作者。",
  },
  {
    id: "r3",
    name: "阿K",
    role: "四格漫画爱好者",
    text: "四格漫画更新特别勤，通勤路上随手翻两格就很开心。节奏快、不拖沓，是我每天放松的首选。",
  },
  {
    id: "r4",
    name: "小满",
    role: "条漫追更用户",
    text: "条漫是竖屏适配的，手机上滑着看很顺滑。收藏夹功能好使，追到一半的作品都能随时接着看。",
  },
];

export const faqs = [
  {
    q: "同人志典藏站是什么样的网站？",
    a: "我们把同人漫画本、插画画集、四格漫画、网络条漫和短篇合集按格式整理打包，读者点击即可整本在线翻阅，不需要自己在各处寻找资源，也方便收藏与反复浏览。",
  },
  {
    q: "作品按什么分类？",
    a: "主要按内容格式分类，包括漫画本、插画画集、四格漫画、网络条漫和短篇合集五类；同时提供校园、奇幻、治愈、战斗、恋爱、悬疑等主题标签，方便按口味筛选。",
  },
  {
    q: "「打包合集」是什么意思？",
    a: "同一部作品的多话、多篇内容会整理成一个完整的合集包，读者一次点击即可从第一话看到最新，无需单独下载每一章，阅读与收藏都更省心。",
  },
  {
    q: "四格漫画和网络条漫有什么区别？",
    a: "四格漫画是经典的「起承转合」四格结构，适合碎片时间随手一翻；网络条漫则是为手机纵向阅读设计的整页长条漫画，追更体验更连贯。两者都会保持独立的格式分区。",
  },
  {
    q: "需要登录或付费吗？",
    a: "当前所有打包作品均免费开放在线阅读，无需登录即可浏览。后续推出的收藏书架、阅读历史等功能会支持账号体系，相关内容会另行说明。",
  },
  {
    q: "如何获取最新作品和精选推荐？",
    a: "可以在页面底部订阅我们的资讯邮件，我们会定期推送新上线作品、热门榜单与编辑精选专栏，不错过任何一部宝藏同人志。",
  },
];

export const stats = [
  { value: "3830+", label: "打包作品" },
  { value: "120万+", label: "累计浏览" },
  { value: "86", label: "合作作者社团" },
  { value: "5", label: "内容格式" },
];